import type { Id } from '@hq/utils';
import { toQuery, type HttpClient } from '../client';
import type {
  FreeAssetListQuery,
  FreeAssetReturnRequest,
  FreeAssetReturnResult,
  FreeAssetRow,
  FreeAssetSaveRequest,
  FreeAssetSaveResult
} from '../types/freeAsset';
import type { PageResult } from '../types/result';

const BASE = '/wl/free-asset';

/** 赠品/免费资产发放台账：查询开放，建档与退回需 `wl:purchase:manage`。 */
export function createFreeAssetApi(http: HttpClient) {
  return {
    list(query: FreeAssetListQuery = {}): Promise<PageResult<FreeAssetRow>> {
      return http.request<PageResult<FreeAssetRow>>({ path: BASE, query: toQuery(query) });
    },

    /** `id` 为空即新建；台账编号由后端生成（`FA-` 前缀）。 */
    save(body: FreeAssetSaveRequest): Promise<FreeAssetSaveResult> {
      return http.request<FreeAssetSaveResult>({ path: BASE, method: 'POST', body });
    },

    /** 退回登记：已发放（ISSUED）→ 已退回（RETURNED）。 */
    returnAsset(id: Id, body: FreeAssetReturnRequest = {}): Promise<FreeAssetReturnResult> {
      return http.request<FreeAssetReturnResult>({
        path: `${BASE}/${id}/return`,
        method: 'POST',
        body
      });
    }
  };
}

export type FreeAssetApi = ReturnType<typeof createFreeAssetApi>;
